import { render, staticRenderFns } from "./OverlayPhotoUpload.vue?vue&type=template&id=66aeb09d&scoped=true"
import script from "./OverlayPhotoUpload.vue?vue&type=script&lang=js"
export * from "./OverlayPhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./OverlayPhotoUpload.vue?vue&type=style&index=0&id=66aeb09d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aeb09d",
  null
  
)

export default component.exports